import { useEffect, useState } from "react";
import api, { API } from "@/lib/api";

export function AuthImage({ fileId, alt, className }) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let url;
    let active = true;
    api.get(`/files/${fileId}/download`, { responseType: "blob" }).then((res) => {
      if (!active) return;
      url = URL.createObjectURL(res.data);
      setSrc(url);
    }).catch(() => {});
    return () => { active = false; if (url) URL.revokeObjectURL(url); };
  }, [fileId]);
  if (!src) return <div className={`animate-pulse bg-slate-200 dark:bg-slate-800 ${className}`} />;
  return <img src={src} alt={alt} className={className} />;
}

export function fileDownloadUrl(fileId) {
  const token = localStorage.getItem("ab_token");
  return `${API}/files/${fileId}/download?auth=${token}`;
}
